import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import translationEN from "./locales/en.json";
import translationJA from "./locales/ja.json";

const resources = {
  en: {
    translation: translationEN,
  },
  ja: {
    translation: translationJA,
  },
};

const SUPPORTED_LANGUAGES = ["en", "ja"];

const normalizeLanguage = (lang) => {
  if (!lang) return "en";
  const base = String(lang).toLowerCase().split("-")[0];
  return SUPPORTED_LANGUAGES.includes(base) ? base : "en";
};

const applyLanguageToUrl = (lang) => {
  const params = new URLSearchParams(window.location.search);

  if (lang === "en") {
    params.delete("lang");
  } else {
    params.set("lang", lang);
  }

  const query = params.toString();
  const nextUrl = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`;
  window.history.replaceState({}, "", nextUrl);
};

const showUnsupportedLanguageMessage = (rawLang) => {
  const existingNotice = document.getElementById("lang-fallback-notice");
  if (existingNotice) {
    existingNotice.remove();
  }

  const notice = document.createElement("div");
  notice.id = "lang-fallback-notice";
  notice.textContent = `The requested language (\"${rawLang}\") is not supported. The application will continue in English.`;
  notice.style.position = "fixed";
  notice.style.top = "16px";
  notice.style.left = "50%";
  notice.style.transform = "translateX(-50%)";
  notice.style.padding = "10px 14px";
  notice.style.background = "#1f2937";
  notice.style.color = "#ffffff";
  notice.style.borderRadius = "6px";
  notice.style.zIndex = "9999";
  notice.style.boxShadow = "0 6px 20px rgba(0, 0, 0, 0.25)";
  notice.style.fontSize = "14px";
  notice.style.maxWidth = "90vw";
  notice.style.textAlign = "center";
  document.body.appendChild(notice);

  return notice;
};

// Language detector configuration
const detectionOptions = {
  order: ['querystring', 'localStorage', 'navigator'],
  lookupQuerystring: 'lang',
  lookupLocalStorage: 'i18nextLng',
  caches: ['localStorage'],
  excludeCacheFor: ['cimode'],
  convertDetectedLanguage: (lng) => normalizeLanguage(lng),
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: "en", // fallback language if selected language is not available
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    cleanCode: true,
    detection: detectionOptions,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  }, () => {
    const params = new URLSearchParams(window.location.search);
    const rawLang = params.get("lang");
    if (!rawLang) return;

    const rawBase = String(rawLang).toLowerCase().split("-")[0];
    const isUnsupportedLanguage = !SUPPORTED_LANGUAGES.includes(rawBase);
    if (isUnsupportedLanguage) {
      const notice = showUnsupportedLanguageMessage(rawLang);
      window.setTimeout(() => {
        i18n.changeLanguage("en");
        applyLanguageToUrl("en");
        if (notice && notice.parentNode) {
          notice.parentNode.removeChild(notice);
        }
      }, 5000);
      return;
    }

    const normalized = normalizeLanguage(rawLang);
    applyLanguageToUrl(normalized);
  });

export default i18n;
